import React, { useMemo } from 'react';
import {
	CONTEXT_TOKEN_TYPE_JIRA,
	ISSUE_NAVIGATOR_ACTION_MODULE,
} from '@atlassian/jira-forge-ui-constants/src/constants.tsx';
import {
	isCustomUIExtension,
	isNativeUiExtension,
} from '@atlassian/jira-forge-ui-utils-internal/src/utils/extension/index.tsx';
import type { IssueNavigatorForgeExtension as IssueNavigatorForgeExtensionType } from '@atlassian/jira-forge-issue-navigator-base/src/ui/extension/index.tsx';
import Placeholder from '@atlassian/react-ufo/placeholder';
import { LazyIssueNavigatorForgeExtension } from '@atlassian/jira-forge-issue-navigator-base/src/ui/async/index.tsx';
import type { LazyComponentProps } from '@atlassian/jira-forge-ui-async/src/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const LazyIssueNavigatorAction = (
	props: LazyComponentProps<typeof IssueNavigatorForgeExtensionType>,
) => {
	const { extension, extensionData, ...restProps } = props;

	const extensionDataValue = useMemo(
		() => ({
			...extensionData,
			type: ISSUE_NAVIGATOR_ACTION_MODULE,
		}),
		[extensionData],
	);
	const extraProps = useMemo(
		() => ({
			module: ISSUE_NAVIGATOR_ACTION_MODULE,
			extensionData: extensionDataValue,
			extension,
			contextToken: CONTEXT_TOKEN_TYPE_JIRA,
		}),
		[extension, extensionDataValue],
	);
	const bridge = useMemo(() => ({ close: props.onClose }), [props.onClose]);

	if (isNativeUiExtension(extension) || isCustomUIExtension(extension)) {
		return (
			<Placeholder name="issue-navigator-action">
				<LazyIssueNavigatorForgeExtension
					{...restProps}
					{...extraProps}
					bridge={bridge}
					hasModalConsentPrompt
					{...(fg('do_not_pass_hide_iframe_prop_to_the_renderer') ? {} : { isIframeHidden: true })}
				/>
			</Placeholder>
		);
	}

	return null;
};

export const AsyncIssueNavigatorAction = LazyIssueNavigatorAction;
